import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=2d21e8a6"
import script from "./FullScreen.vue?vue&type=script&lang=js"
export * from "./FullScreen.vue?vue&type=script&lang=js"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=2d21e8a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports